/* IT Gallery — gaming laptop free-gift promos (auto-expires via Liquid gate)
   1) Auto-adds each free gift when its qualifying laptop is in the cart, removes it
      when the laptop is gone. Free prices come from automatic Buy-X-Get-Y discounts.
   2) Fast path: when a qualifying laptop add request is detected, its gift is added
      immediately (no cart pre-fetch), then the drawer (side-cart section) is
      re-rendered in place.
   3) Repositions the promo banners into their correct page slots. */
(function () {
  var P = window.ITG_PROMO || {};
  if (P.active === false) return;

  var GIFT_PROP = '_itg_free_gift';
  /* Each pair: buy = qualifying laptop variant id, gift = free product variant id,
     val = gift tag, giftInCart = cached knowledge (null = unknown). */
  var PAIRS = (P.pairs || []).map(function (p) {
    return { buy: String(p.buy || ''), gift: String(p.gift || ''), val: String(p.val || ''), giftInCart: null };
  }).filter(function (p) { return p.buy && p.gift && p.val; });
  var busy = false;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addGift(p) {
    var props = {}; props[GIFT_PROP] = p.val;
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(p.gift), quantity: 1, properties: props }] })
    });
  }
  function removeGift(key) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  /* Re-render the side-cart drawer from the live cart; badge count is read from the
     rendered section itself (header[data-totalqty]) — no extra cart fetch needed. */
  function refreshDrawer() {
    var drawer = document.getElementById('cart'); // <aside id="cart" class="m6pn">
    return fetch(ROOT + '?section_id=side-cart', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var section = tpl.querySelector('.shopify-section') || tpl.firstElementChild;
        if (!section) return;
        /* Swap content INSIDE the existing .shopify-section wrapper (the theme's
           drawer layout CSS depends on it); fall back to #cart only if absent. */
        var target = drawer ? (drawer.querySelector('.shopify-section') || drawer) : null;
        if (target) target.innerHTML = section.innerHTML;
        var head = section.querySelector('header[data-totalqty]');
        if (head) {
          var qty = head.getAttribute('data-totalqty');
          document.querySelectorAll('#cart-count').forEach(function (el) {
            el.textContent = ' ' + qty;
          });
        }
      })
      .catch(function () {})
      .then(notifyTheme);
  }

  function notifyTheme() {
    ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxCart.afterCartLoad'].forEach(function (ev) {
      try { document.dispatchEvent(new CustomEvent(ev)); } catch (e) {}
    });
  }

  /* Fast path: a qualifying laptop add detected in the outgoing request —
     add that pair's gift at once. */
  function fastAddGift(p) {
    if (busy) return;
    busy = true;
    addGift(p)
      .then(function (r) {
        if (r && r.ok) { p.giftInCart = true; }
        return refreshDrawer();
      })
      .catch(function () { p.giftInCart = null; })
      .then(function () {
        busy = false;
        if (p.giftInCart !== true) reconcile(); // fallback if the fast add failed
      });
  }

  /* Full reconcile: fetch the cart, then add/remove each pair's gift as needed. */
  function reconcile() {
    if (busy || !PAIRS.length) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var items = cart.items || [];
      var ops = [];
      PAIRS.forEach(function (p) {
        var hasBuy = items.some(function (it) { return String(it.variant_id) === p.buy; });
        var gift = items.filter(function (it) {
          return String(it.variant_id) === p.gift && it.properties && it.properties[GIFT_PROP] === p.val;
        })[0] || null;
        p.giftInCart = !!gift;
        if (hasBuy && !gift) {
          ops.push(function () { return addGift(p).then(function () { p.giftInCart = true; }); });
        } else if (!hasBuy && gift) {
          ops.push(function () { return removeGift(gift.key).then(function () { p.giftInCart = false; }); });
        }
      });
      if (!ops.length) return;
      return ops.reduce(function (chain, op) { return chain.then(op); }, Promise.resolve()).then(refreshDrawer);
    }).catch(function () {}).then(function () { busy = false; });
  }

  /* Watch cart-changing requests; use the fast path when a qualifying laptop is added. */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;

  function bodyToString(b) {
    try {
      if (!b) return '';
      if (typeof b === 'string') return b;
      if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) return b.toString();
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        var parts = [];
        b.forEach(function (v, k) { parts.push(k + '=' + v); });
        return parts.join('&');
      }
    } catch (e) {}
    return '';
  }
  function pairForAddBody(bodyStr) {
    if (!bodyStr) return null;
    for (var i = 0; i < PAIRS.length; i++) {
      if (bodyStr.indexOf(PAIRS[i].buy) !== -1) return PAIRS[i];
    }
    return null;
  }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var watch = CART_WRITE.test(url) && !busy;
      var addPair = (watch && CART_ADD.test(url)) ? pairForAddBody(bodyToString(init && init.body)) : null;
      return _fetch.apply(this, arguments).then(function (res) {
        if (watch && res && res.ok) {
          if (addPair && addPair.giftInCart === false) fastAddGift(addPair);
          else setTimeout(reconcile, 10);
        }
        return res;
      });
    };
  }
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__itgUrl = u; return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      var url = this.__itgUrl || '';
      if (CART_WRITE.test(url) && !busy) {
        var addPair = CART_ADD.test(url) ? pairForAddBody(bodyToString(body)) : null;
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            if (addPair && addPair.giftInCart === false) fastAddGift(addPair);
            else setTimeout(reconcile, 10);
          }
        });
      }
      return _send.apply(this, arguments);
    };
  }

  function reveal(el) { if (!el) return; el.removeAttribute('hidden'); el.classList.remove('itg-prepos'); }

  function firstDirectSection(parent) {
    var kids = parent.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].classList && kids[i].classList.contains('shopify-section')) return kids[i];
    }
    return null;
  }

  function positionBanners() {
    var content = document.getElementById('content');
    var home = document.querySelector('[data-itg-slot="home"]');
    if (home && content) {
      var hero = firstDirectSection(content); // the hero/slideshow is the first section
      if (hero && hero.parentNode) { hero.parentNode.insertBefore(home, hero.nextSibling); }
      else { content.insertBefore(home, content.firstChild); }
      reveal(home);
    }
    var coll = document.querySelector('[data-itg-slot="collection"]');
    if (coll && content) { content.insertBefore(coll, content.firstChild); reveal(coll); }
    var prod = document.querySelector('[data-itg-slot="product"]');
    if (prod) {
      var anchor = document.querySelector('form[action*="/cart/add"]')
        || document.querySelector('.product-form, .product__info, .pf_inner, [data-product-form]');
      if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(prod, anchor); }
      reveal(prod);
    }
  }

  function initStickyVideo() {
    var v = document.getElementById('itg-svid');
    if (!v) return;
    var KEY = 'itg_svid_closed';
    try { if (sessionStorage.getItem(KEY) === '1') return; } catch (e) {}
    v.classList.remove('itg-hide');
    var btn = v.querySelector('.itg-svid__close');
    if (btn) btn.addEventListener('click', function () {
      v.classList.add('itg-hide');
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    });
  }

  /* Hero offer carousel: auto-rotates every 6s, dots, swipe, pause on hover. */
  function initHeroSlider() {
    var hero = document.querySelector('[data-itg-slot="home"]');
    if (!hero) return;
    var track = hero.querySelector('.itg-hero__track');
    if (!track) return;
    var slides = track.children;
    var dots = hero.querySelectorAll('.itg-hero__dot-btn');
    if (slides.length < 2) return;
    var idx = 0, timer = null, reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    function go(i) {
      idx = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === idx);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() { if (reduce) return; stop(); timer = setInterval(function () { go(idx + 1); }, 6000); }
    for (var d = 0; d < dots.length; d++) (function (n) {
      dots[n].addEventListener('click', function () { go(n); play(); });
    })(d);
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      x0 = null; play();
    }, { passive: true });
    go(0); play();
  }

  function init() { positionBanners(); reconcile(); initStickyVideo(); initHeroSlider(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
